module.exports = __webpack_public_path__ + "img/thumbnail_SussexChicken_m_erythristic.b5dae426.png";